export const meta = {
  id: 'point-in-polygon',
  name: 'Point in Polygon',
  category: 'Geometry',
  complexity: {
    time: 'O(n)',
    space: 'O(1)'
  },
  description: 'Point in Polygon test using the ray casting algorithm. Determines whether a point lies inside, outside, or on the boundary of a polygon.'
};
